import { useSelector } from "react-redux";
import { get } from "lodash";

export default function useEntityList(entity) {
  return useSelector((state) =>
    (state.entities[entity]?.allIds || []).map((id) => get(state.entities[entity]["byId"], id, undefined))
  );
}
